import React from 'react';
import {observer} from "mobx-react-lite";

const Main = () => {
    return (
        <main className="main no-file">
            Выберите файл
        </main>
    );
};

export default observer(Main);